var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.478,
    height: 90,
    viewBox: "0 0 84.478 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8a8a8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Abilities",
    transform: "translate(-4.7 -2.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15691",
    "data-name": "Path 15691",
    d: "M57.622,25.087,43.145,33.445c0-.149-.149-.448-.149-.6l-.9-2.239L56.279,22.4A5.731,5.731,0,0,0,57.622,25.087Z",
    transform: "translate(18.421 9.604)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15692",
    "data-name": "Path 15692",
    d: "M29.221,30.609a16.175,16.175,0,0,0-1.194,2.836L13.4,25.087A7.826,7.826,0,0,0,14.893,22.4Z",
    transform: "translate(4.285 9.604)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15693",
    "data-name": "Path 15693",
    d: "M14.893,22.978A8.737,8.737,0,0,0,13.4,20.44L34,8.5a11.2,11.2,0,0,0,1.194,2.687Z",
    transform: "translate(4.285 2.758)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15694",
    "data-name": "Path 15694",
    d: "M9.293,26.549a5.077,5.077,0,0,0,1.493-.149V49.833a5.077,5.077,0,0,0-1.493-.149,5.077,5.077,0,0,0-1.493.149V26.4c.448,0,.9.149,1.493.149Z",
    transform: "translate(1.527 11.575)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15695",
    "data-name": "Path 15695",
    d: "M16.733,51.345c-.3.9-.6,1.94-.9,2.985L13.3,52.837A8.737,8.737,0,0,0,14.793,50.3Z",
    transform: "translate(4.236 23.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15696",
    "data-name": "Path 15696",
    d: "M30.664,40.887l-15.672,9.1A6.871,6.871,0,0,0,13.5,47.3l15.821-9.1Z",
    transform: "translate(4.334 17.387)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15697",
    "data-name": "Path 15697",
    d: "M34.985,12.9V27.378H32V12.9a5.077,5.077,0,0,0,1.493.149,5.078,5.078,0,0,0,1.493-.149Z",
    transform: "translate(13.446 4.925)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15698",
    "data-name": "Path 15698",
    d: "M59.791,20.391A8.737,8.737,0,0,0,58.3,22.928L38,11.287A6.22,6.22,0,0,0,39.194,8.6Z",
    transform: "translate(16.401 2.807)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15699",
    "data-name": "Path 15699",
    d: "M58.015,47.3a7.826,7.826,0,0,0-1.493,2.687L41,40.887,42.343,38.2Z",
    transform: "translate(17.879 17.387)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15700",
    "data-name": "Path 15700",
    d: "M53.684,52.837,51.3,54.33a11.372,11.372,0,0,0-.9-2.985L52.191,50.3a8.737,8.737,0,0,0,1.493,2.537Z",
    transform: "translate(22.509 23.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15701",
    "data-name": "Path 15701",
    d: "M59.185,26.4V49.833a7.537,7.537,0,0,0-2.985,0V26.4a5.078,5.078,0,0,0,1.493.149c.448,0,1.045-.149,1.493-.149Z",
    transform: "translate(25.366 11.575)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6491",
    "data-name": "Group 6491",
    transform: "translate(4.7 2.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15702",
    "data-name": "Path 15702",
    d: "M16.939,50.119a6.053,6.053,0,0,1-6.119,6.119,6.119,6.119,0,1,1,6.119-6.119Z",
    transform: "translate(-4.7 17.343)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15703",
    "data-name": "Path 15703",
    d: "M16.939,22.419A6.119,6.119,0,1,1,10.819,16.3,6.352,6.352,0,0,1,16.939,22.419Z",
    transform: "translate(-4.7 3.7)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15704",
    "data-name": "Path 15704",
    d: "M41.139,9.019a6.147,6.147,0,0,1-6.119,6.119A6.053,6.053,0,0,1,28.9,9.019a6.119,6.119,0,1,1,12.239,0Z",
    transform: "translate(7.219 -2.9)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15705",
    "data-name": "Path 15705",
    d: "M65.339,22.419a6.147,6.147,0,0,1-6.119,6.119A6.053,6.053,0,0,1,53.1,22.419,6.147,6.147,0,0,1,59.219,16.3,6.352,6.352,0,0,1,65.339,22.419Z",
    transform: "translate(19.139 3.7)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15706",
    "data-name": "Path 15706",
    d: "M65.339,50.119A6.119,6.119,0,1,1,59.219,44,6.147,6.147,0,0,1,65.339,50.119Z",
    transform: "translate(19.139 17.343)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6492",
    "data-name": "Group 6492",
    transform: "translate(22.76 35.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15707",
    "data-name": "Path 15707",
    d: "M24.9,36.59a12.114,12.114,0,0,1,23.582-3.881c1.493,4.179.149,10.3-3.134,14.776-2.388,3.433-5.373,5.373-8.358,5.373-6.866,0-12.09-9.851-12.09-16.269Z",
    transform: "translate(-12.81 -24.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15708",
    "data-name": "Path 15708",
    d: "M65.158,61.315v9.7a1.5,1.5,0,0,1-1.493,1.493H18.293A1.41,1.41,0,0,1,16.8,71.016v-9.7A17.1,17.1,0,0,1,32.621,44.3H49.337A16.986,16.986,0,0,1,65.158,61.315Z",
    transform: "translate(-16.8 -14.748)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbilities);
export default __webpack_public_path__ + "static/media/Abilities.848e1656eb722ece16cd22d7c90f1bc5.svg";
export { ForwardRef as ReactComponent };